import React from "react";
import { Alert, Box, Grid, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DashboardDeferredBanner from "../DashboardDeferredBanner";

export const DASHBOARD_KPI_SKELETON_HEIGHT = 118;
export const DASHBOARD_CHART_SKELETON_HEIGHT = 300;

export function DashboardKpiSkeleton({ height = DASHBOARD_KPI_SKELETON_HEIGHT, sx }) {
  return <Skeleton height={height} sx={{ width: "100%", borderRadius: 1, ...sx }} />;
}

export function DashboardChartSkeleton({ height = DASHBOARD_CHART_SKELETON_HEIGHT, sx }) {
  return <Skeleton variant="rectangular" height={height} sx={{ width: "100%", borderRadius: 1, ...sx }} />;
}

/** Linha de KPIs placeholder (padrão dashboard). */
export function DashboardKpiGridSkeleton({
  count = 4,
  spacing = 2,
  sx,
  itemProps = { xs: 12, sm: 6, md: 3 },
}) {
  return (
    <Grid container spacing={spacing} sx={sx}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item key={index} {...itemProps}>
          <DashboardKpiSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}

/** Layout skeleton da aba Pesquisas (3 KPIs + gráfico + bloco inferior). */
export function DashboardSurveysTabSkeleton() {
  return (
    <Box>
      <DashboardKpiGridSkeleton
        count={3}
        spacing={3}
        sx={{ mb: 3 }}
        itemProps={{ xs: 12, sm: 6, md: 4 }}
      />
      <DashboardChartSkeleton height={320} sx={{ mb: 3 }} />
      <DashboardChartSkeleton height={180} />
    </Box>
  );
}

/**
 * Barra superior padronizada: banner deferido/preview, erro e carregamento inicial.
 */
export function DashboardTabChrome({
  isDeferred = false,
  isPreview = false,
  isInitialLoading = false,
  errorMessage = null,
  emptyState = null,
  previewPendingMessage = null,
}) {
  const { t } = useTranslation("settings");
  const showEmpty = emptyState?.visible && !isInitialLoading && !errorMessage;

  return (
    <Box sx={{ mb: 2 }}>
      <DashboardDeferredBanner visible={isDeferred || isPreview} preview={isPreview} />

      {errorMessage ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      ) : null}

      {showEmpty ? (
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {emptyState.title}
          </Typography>
          {emptyState.hint ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {emptyState.hint}
            </Typography>
          ) : null}
        </Alert>
      ) : null}

      {!isInitialLoading && !errorMessage && isPreview && previewPendingMessage ? (
        <Alert severity="info" sx={{ mb: 0 }}>
          {previewPendingMessage}
        </Alert>
      ) : null}
    </Box>
  );
}
